import { useCallback } from 'react'
import { Layer, Marker, Source } from 'react-map-gl'
import { PiFootprintsFill } from 'react-icons/pi'
import { useXp } from '../contexts/XpContext'
import { POSITION_MARKER_COLOR } from '../utils/constants/map.constants'
import { useDevice } from '../hooks/device'
import { useMapControls } from '../contexts/MapControlsContext'

const ManualLocationMarker = () => {
  const { manualMode, location, updateLocation } = useXp()
  const { dragging, setDragging } = useMapControls()
  const device = useDevice()
  const platformType = device?.platformType
  const center: [number, number] = [location?.coords?.longitude ?? 0, location?.coords?.latitude ?? 0]

  const feature = {
    type: 'Feature' as const,
    id: 'manual_position_feature',
    properties: {},
    geometry: {
      type: 'Point' as const,
      coordinates: center,
    },
  }

  const circleStyle = {
    id: 'manual_position_circle',
    type: 'circle' as const,
    paint: {
      'circle-radius': 14,
      'circle-stroke-color': POSITION_MARKER_COLOR.stroke,
      'circle-stroke-opacity': 0.5,
      'circle-stroke-width': 1,
      'circle-stroke-color-transition': {
        duration: 1000,
        delay: 0,
      },
      'circle-color': POSITION_MARKER_COLOR.fill,
      'circle-opacity': 0.5,
      'circle-color-transition': {
        duration: 1000,
        delay: 0,
      },
    },
  }

  const handleDragEnd = useCallback(
    (event: { lngLat: { lng: number; lat: number } }) => {
      if (manualMode) {
        const { lng, lat } = event.lngLat
        updateLocation({ latitude: lat, longitude: lng })
      }
      setDragging(false)
    },
    [manualMode, updateLocation]
  )

  return (
    <>
      {location?.coords && (
        <>
          {!dragging && (
            <Source id="manual_position_source" type="geojson" data={feature}>
              <Layer {...circleStyle} />
            </Source>
          )}
          <Marker
            longitude={location.coords.longitude}
            latitude={location.coords.latitude}
            anchor="center"
            draggable={platformType !== 'mobile'}
            onDragStart={() => setDragging(true)}
            onDragEnd={handleDragEnd}
          >
            <PiFootprintsFill
              className="w-5 h-5"
              style={{
                color: POSITION_MARKER_COLOR.icon,
              }}
              data-testid="manual-location-marker"
            />
          </Marker>
        </>
      )}
    </>
  )
}

export default ManualLocationMarker
